import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AvatarEditor from 'react-avatar-editor';
import Slider from 'rc-slider/lib/Slider';
import 'rc-slider/assets/index.css';
import { Button, Col, Container, Form, FormFile, Row, Spinner } from 'react-bootstrap';

const FieldFileInput = props => {
  const {
    onChange,
    value,
    setError,
    clearError,
    errors,
    limitSize,
    accept,
    aeSize,
    classNames,
    label,
    minWidth = 1,
    minHeight = 1,
    ...other
  } = props;

  const type = props['data-type'];
  const name = props['data-name'];

  const [imgCropped, setImgCropped] = useState({
    srcFile: null,
    srcImg: null,
    cropResultFile: null,
    cropResultImg: null,
  });

  const [editorImg, setEditorImg] = useState({ scale: 1 });

  let { isLoadingImageFile } = useSelector(state => state.course);

  let ET;

  function checkImageWidthAndHeight(file) {
    return new Promise((resolve, reject) => {
      var fr = new FileReader();
      fr.onload = () => {
        var img = new Image();
        img.onload = function() {
          if (img.width < minWidth || img.height < minHeight) {
            setError(
              name,
              'notMatch',
              `لطفا فایلی با اندازه مناسب وارد کنید(حداقل  طول و عرض تصویر${minWidth} در ${minHeight} پیکسل)`
            );
            reject();
          } else {
            resolve();
          }
        };
        img.src = fr.result;
      };
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });
  }

  const handleChange = e => {
    const file = e.target.files[0];
    const fileSize = Math.ceil(file.size / 1000000);
    const fileType = file.type;

    if (type === 'image') {
      setImgCropped({
        srcFile: null,
        srcImg: null,
        cropResultFile: null,
        cropResultImg: null,
      });
      e.persist();
    }

    clearError(name);
    if (fileType.includes(type)) {
      if (fileSize > limitSize) {
        setError(name, 'notMatch', `لطفا فایل را با اندازه مناسب وارد کنید(حداکثر ${limitSize} مگابایت)`);
        return;
      }

      if (type === 'video') {
        onChange(file);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setImgCropped({
          srcFile: file,
          srcImg: reader.result,
          cropResultFile: null,
          cropResultImg: null,
        });
      };

      checkImageWidthAndHeight(file).then(function() {
        reader.readAsDataURL(file);
      });
    } else {
      setError(name, 'notMatch', 'لطفا فایل با فرمت مناسب انتخاب کنید.');
      return;
    }
  };

  const cropImage = e => {
    let base64File = ET.getImage().toDataURL();
    let file = base64toFile(base64File);
    let newImgCropped = {
      ...imgCropped,
      cropResultFile: file,
      cropResultImg: base64File,
    };
    setImgCropped(newImgCropped);
  };

  useEffect(() => {
    if (imgCropped.cropResultFile) {
      onChange(imgCropped.cropResultFile);
      other.uploadFile(imgCropped.cropResultFile, name);
    }

    // eslint-disable-next-line
  }, [imgCropped.cropResultFile]);

  // useEffect(() => {

  //   value
  //     ? setImgCropped(value)
  //     : setImgCropped({
  //         srcFile: null,
  //         srcImg: null,
  //         cropResultFile: null,
  //         cropResultImg: null,
  //       });

  //   // eslint-disable-next-line
  // }, [value]);

  const setEditorRef = editor => {
    if (editor) {
      ET = editor;
    }
  };

  const handleScale = value => {
    const scale = parseFloat(value);
    setEditorImg({ scale });
  };

  return (
    <Fragment>
      <div className="input-group">
        <div className={classNames.container}>
          <Form.File
            type="file"
            className={classNames.input}
            onChange={handleChange}
            accept={accept}
            data-type={type}
            id="input"
          />
          <Form.File.Label className={classNames.label} htmlFor="input">
            {label}
          </Form.File.Label>
        </div>
      </div>
      {type === 'image' && imgCropped.srcFile && (
        <Container className="px-0">
          <Row className="my-4">
            <Col md={1}>
              <Slider
                vertical
                trackStyle={{ backgroundColor: '#5867dd' }}
                railStyle={{ backgroundColor: 'rgba(0,0,0,0.3)' }}
                handleStyle={{ borderColor: '#5867dd' }}
                min={1}
                max={3}
                defaultValue={editorImg.scale}
                onChange={handleScale}
                step="0.01"
              />
            </Col>
            <Col md={8}>
              <AvatarEditor
                ref={setEditorRef}
                image={imgCropped.srcImg}
                width={aeSize?.width}
                height={aeSize?.height}
                border={50}
                scale={editorImg.scale}
                color={[0, 0, 0, 0.6]}
              />
            </Col>
            <Col md={3}>
              <Row>
                <Button onClick={cropImage} block disabled={isLoadingImageFile}>
                  {isLoadingImageFile ? <Spinner animation={'border'} variant={'light'} /> : 'اعمال برش تصویر و آپلود'}
                </Button>
                <ul className="pl-3 my-3">
                  <li>با استفاده از اسکرول موس می‌توانید تصویر را کوچک یا بزرگ کنید.</li>
                  <li>در هر بار ویرایش اطلاعات نیازی به برش عکس نیست وتنها در صورت دلخواه تصویر را ویرایش کنید.</li>
                </ul>
              </Row>

              <Row>
                {imgCropped.cropResultImg && (
                  <img src={imgCropped.cropResultImg} alt="the cropped" style={{ width: '100%', display: 'block' }} />
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </Fragment>
  );
};

function base64toFile(dataurl, filename) {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export default FieldFileInput;
